import one from '@images/renders/infrastructure_images/Infra_Desktop_Webp/9.webp';
import two from '@images/renders/infrastructure_images/Infra_Desktop_Webp/10.webp';
import three from '@images/renders/infrastructure_images/Infra_Desktop_Webp/11.webp';
import four from '@images/renders/infrastructure_images/Infra_Desktop_Webp/12.webp';
import five from '@images/renders/infrastructure_images/Infra_Desktop_Webp/13.webp';
import one_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/9.webp';
import two_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/10.webp';
import redBookImg1 from '@images/renders/landscaping_images/scroll_images/scroll_1.webp';
import redBookImg1_plug from '@images/renders/landscaping_images/scroll_images/scroll_1_plug.webp';
import redBookImg2 from '@images/renders/landscaping_images/scroll_images/scroll_2.webp';
import redBookImg2_plug from '@images/renders/landscaping_images/scroll_images/scroll_2_plug.webp';
import redBookImg3 from '@images/renders/landscaping_images/scroll_images/scroll_3.webp';
import redBookImg3_plug from '@images/renders/landscaping_images/scroll_images/scroll_3_plug.webp';
import location_1 from '@images/renders/location_images/slider-1.webp';
import location_1_mob from '@images/renders/location_images/slider-1-mob.webp';
import location_2 from '@images/renders/location_images/slider-2.webp';
import location_2_mob from '@images/renders/location_images/slider-2-mob.webp';
import location_3 from '@images/renders/location_images/slider-3.webp';
import location_3_mob from '@images/renders/location_images/slider-3-mob.webp';
import location_4 from '@images/renders/location_images/slider-4.webp';
import location_4_mob from '@images/renders/location_images/slider-4-mob.webp';
import location_5 from '@images/renders/location_images/slider-5.webp';
import location_5_mob from '@images/renders/location_images/slider-5-mob.webp';
import location_6 from '@images/renders/location_images/slider-6.webp';
import location_6_mob from '@images/renders/location_images/slider-6-mob.webp';
import location_7 from '@images/renders/location_images/slider-7.webp';
import location_7_mob from '@images/renders/location_images/slider-7-mob.webp';

import img1 from '@images/renders/scroll_images/scroll_1_new.webp';
import img2 from '@images/renders/scroll_images/scroll_2_new.webp';
import img3 from '@images/renders/scroll_images/scroll_3_new.webp';
import img4 from '@images/renders/scroll_images/scroll_4_new.webp';
import img5 from '@images/renders/scroll_images/scroll_5_new.webp';

export const scrollInfo = [
  {
    text: '<p>Атмосфера</p> <p>загородного</p> <p>отдыха</p>',
    src: `${img1.src}`,
    srcXS: `${img1.src}`,
    rotate: 0.82,
    top: 5,
    id: 1,
  },
  {
    text: '<p>Жизнь</p> <p>рядом</p> <p>с Красной книгой</p>',
    src: `${img2.src}`,
    srcXS: `${img2.src}`,
    rotate: -2.42,
    top: 0,
    id: 2,
  },
  {
    text: '<p>Особый</p> <p>лайфстайл</p>',
    src: `${img3.src}`,
    srcXS: `${img3.src}`,
    rotate: 0.1,
    top: 5,
    id: 3,
  },
  {
    text: '<p>На берегу</p> <p>зелёного</p> <p>океана</p>',
    src: `${img4.src}`,
    srcXS: `${img4.src}`,
    rotate: -1.16,
    top: 0,
    id: 4,
  },

  {
    text: '<p>Всё важное</p>  <p>рядом</p>',
    src: `${img5.src}`,
    srcXS: `${img5.src}`,
    rotate: 1.29,
    top: 5,
    id: 5,
  },
];

export const redBookScroll = [
  {
    src: redBookImg1.src,
    srcXS: redBookImg1.src,
    rotate: -2.68,
    rotateMob: -2.68,
    top: 7,
    topMob: 5,
    plug: redBookImg1_plug.src,
    padding: 0,
    id: 1,
  },
  {
    src: redBookImg2.src,
    srcXS: redBookImg2.src,
    rotate: 0,
    rotateMob: 5.39,
    top: 10,
    topMob: 15,
    plug: redBookImg2_plug.src,
    padding: 3,
    id: 2,
  },
  {
    src: redBookImg3.src,
    srcXS: redBookImg3.src,
    rotate: 3.57,
    rotateMob: 3.57,
    top: 5,
    topMob: 5,
    plug: redBookImg3_plug.src,
    padding: 0,
    id: 3,
  },
];

export const scrollInfrastructure = [
  {
    text: '<p>Атмосфера</p> <p>загородного</p> <p>отдыха</p>',
    src: `${one.src}`,
    srcXS: `${one_Mob.src}`,
    rotate: -7.96,
    top: 0,
    id: 1,
  },
  {
    text: '<p>Понежиться</p> <p> в шезлонге</p>',
    src: `${two.src}`,
    srcXS: `${two_Mob.src}`,
    rotate: -2.97,
    top: 5,
    id: 2,
  },
  {
    text: '<p>Устроить</p> <p>пикник</p>',
    src: `${three.src}`,
    srcXS: `${three.src}`,
    rotate: 0.1,
    top: -1,
    id: 3,
  },
  {
    text: '<p>Сыграть</p> <p>партию</p> <p>в шахматы</p>',
    src: `${four.src}`,
    srcXS: `${four.src}`,
    rotate: -2.04,
    top: 2,
    id: 4,
  },

  {
    text: '<p>Иммерсивное</p>  <p>благоустройство</p>',
    src: `${five.src}`,
    srcXS: `${five.src}`,
    rotate: 1,
    top: -3,
    id: 5,
  },
];

export const scrollLocation = [
  {
    text: '<p>Парк Покровское-</p> <p> Стрешнево</p>',
    src: `${location_1.src}`,
    srcXS: `${location_1_mob.src}`,
    rotate: -7.96,
    top: 0,
    id: 1,
  },
  {
    text: '<p>Торговый центр</p> <p> Метрополис</p>',
    src: `${location_2.src}`,
    srcXS: `${location_2_mob.src}`,
    rotate: -2.97,
    top: 5,
    id: 2,
  },
  {
    text: '<p>Усадьба Покровское-</p> <p> Стрешнево</p>',
    src: `${location_3.src}`,
    srcXS: `${location_3_mob.src}`,
    rotate: 0.1,
    top: -1,
    id: 3,
  },
  {
    text: '<p>Стадион</p> <p> &laquo;Открытие Арена&raquo;</p>',
    src: `${location_4.src}`,
    srcXS: `${location_4_mob.src}`,
    rotate: -2.04,
    top: 2,
    id: 4,
  },

  {
    text: '<p>Фитнес-центр</p>',
    src: `${location_5.src}`,
    srcXS: `${location_5_mob.src}`,
    rotate: 1,
    top: -3,
    id: 5,
  },

  {
    text: '<p>Щукинский</p>  <p> парк</p>',
    src: `${location_6.src}`,
    srcXS: `${location_6_mob.src}`,
    rotate: -3,
    top: 3,
    id: 6,
  },

  {
    text: '<p>Всехсвятская</p>  <p> роща</p>',
    src: `${location_7.src}`,
    srcXS: `${location_7_mob.src}`,
    rotate: 2,
    top: -3,
    id: 7,
  },
];
